import React, { Component } from "react";
import Config from './Config';
import {Modal, Button} from 'react-bootstrap';
 
class Order extends Component {
  constructor(props){
    super(props);
    this.state = {orders: [], vendors: [], customers: [], show: false, order : {}};
    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  handleClose() {
    this.setState({ show: false });
  }

  handleShow(order) {
    this.setState({order : order});
    this.setState({ show: true });
  }

  componentDidMount() {
    this.fetchData();
  }
  fetchData(){
    fetch(Config.order.orderUrl).then(results => {
      return results.json();
    })
    .then(data => {
      this.setState({ orders: data.order })
      }
    ).then(() => {
      if(localStorage.getItem(Config.vendor.type)){
        return JSON.parse(localStorage.getItem(Config.vendor.type))
      } else {
        return fetch(Config.vendor.url)
      }
    }).then(results => {
      return (results.json !== undefined && typeof results.json === 'function') ? results.json() : { vendor : results };
    }).then(data => {
      if(!localStorage.getItem(Config.vendor.type)){
        localStorage.setItem(Config.vendor.type, JSON.stringify(data.vendor) );
      }
        this.setState({ vendors: data.vendor })
      }
    ).then(() => {
      if(localStorage.getItem(Config.customer.type)){
        return JSON.parse(localStorage.getItem(Config.customer.type))
      } else {
        return fetch(Config.customer.url)
      }
    }).then(results => {
      return (results.json !== 'undefined' && typeof results.json === 'function') ? results.json() : { customer :results };
    }).then(data => {
      if(!localStorage.getItem(Config.customer.type)){
        localStorage.setItem(Config.customer.type, JSON.stringify(data.customer) );
      }
      this.setState({ customers: data.customer })
    }
    ).catch(function(err) {
      console.log('Fetch Error :', err);
    });
    // this.setState({ orders: orders.order });
  }

  render() {
    const vendors = this.state.vendors;
    const customers = this.state.customers;
    const order = this.state.order;
    
    return (
      <div className="App">
        <label>{Config.order.title}&nbsp;&nbsp;&nbsp;&nbsp;<button className="btn btn-sm btn-danger" onClick={(e) => {
                        this.fetchData();
                        }}>Refresh</button></label>
        <OrderModule orders={this.state.orders} vendors={vendors} customers={customers} handleClick={this.handleShow}/>
        {this.state.show &&
          <Modal show={this.state.show} onHide={this.handleClose}>
            <Modal.Header closeButton>
            </Modal.Header>
            <Modal.Body>
              <OrderSummary order={order} vendor={vendors.find(vendor => vendor.id === order.vendor_id)} customer={customers.find(customer => customer.id === order.customer_id)}/>
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={this.handleClose}>Close</Button>
            </Modal.Footer>
          </Modal>
         
        }
      </div>
    );
  }
}

class OrderModule extends Component {
  render(){
    const orders = this.props.orders;
    const vendors = this.props.vendors;
    const customers = this.props.customers;
    const rows = [];
    orders.forEach((order) => {
      rows.push(<OrderDetails order={order} vendor={vendors.find(vendor => vendor.id === order.vendor_id)} customer={customers.find(customer => customer.id === order.customer_id)} key={order.id} handleClick={this.props.handleClick}/>);
    });
    return(
      <div className="table-responsive">
        <table className="table table-hover">
          <thead>
            <tr>
              <th className="order-title">Bill No</th>
              <th className="order-title">Lorry No</th>
              <th className="order-title">Customer</th>
              <th className="order-title">Vendor</th>
              <th className="order-title">Total Qty</th>
              <th className="order-title">Total Amt</th>
              <th className="order-title">SGST</th>
              <th className="order-title">CGST</th>
              <th className="order-title">Total Amt after tax</th>
            </tr>
          </thead>
          <tbody>{rows}</tbody>
        </table>
      </div>
    );
  }
}

class OrderDetails extends Component {
  constructor(props){
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e){
    e.preventDefault();
    this.props.handleClick(this.props.order);
  }

  render(){
    const order = this.props.order;
    const vendor = this.props.vendor ? this.props.vendor : [];
    const customer = this.props.customer ? this.props.customer : [];
    return (
      <tr onClick={this.handleClick}>
        <td>{order.bill_no}</td>
        <td>{order.lorry_no}</td>
        <td>{customer.name}</td>
        <td>{vendor.name}</td>
        <td>{order.total_qty}</td>
        <td>{order.total_amt_before_tax}</td>
        <td>{order.sgst_amount}</td>
        <td>{order.cgst_amount}</td>
        <td>{order.total_amount}</td>
      </tr>
    );
  }
}

class OrderSummary extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      rows : [],
      order: props.order
    };
  }

  componentDidMount() {
      const rows = [];
      const order = this.state.order;
      let id = order.id;
      fetch(Config.order.orderDetailUrl+id)
      .then(results => {
        return results.json();
      })
      .then(data => {
        data.orderitem.forEach((orderitem) => {
            rows.push(<OrderItemDetails key={orderitem.id} orderitem={orderitem} item={data.item.find(item => item.id === orderitem.item_id)} />);
          });
          this.setState({rows: rows, order: data.order[0]});
        }
      ).catch(function(err) {
        console.log('Fetch Error :', err);
      });
  }

  render() {
    const order = this.state.order;
    const vendor = this.props.vendor ? this.props.vendor : [];
    const customer = this.props.customer ? this.props.customer : [];
      return (
        <div>
          <section className="order-summary">
            <div className="table-responsive">
              <table className="table">
                <tbody>
                  <tr>
                    <td>Bill No</td>
                    <td style={{textAlign: "justify"}}>{order.bill_no}</td>
                  </tr>
                  <tr>
                    <td>Lorry No</td>
                    <td style={{textAlign: "justify"}}>{order.lorry_no}</td>
                  </tr>
                  <tr>
                    <td>Driver No</td>
                    <td style={{textAlign: "justify"}}>{order.lorry_mobile_no}</td>
                  </tr>
                  <tr>
                    <td>EWAY Bill No</td>
                    <td style={{textAlign: "justify"}}>{order.eway_bill_no}</td>
                  </tr>
                  <tr style={{textAlign: "justify"}}>
                    <td>Customer</td>
                    <td>{customer.name} <br />GST: {customer.gstno}</td>
                  </tr>
                  <tr style={{textAlign: "justify"}}>
                    <td>Vendor</td>
                    <td>{vendor.name} <br />GST: {vendor.gstno}</td>
                  </tr>
                  <tr>
                    <td style={{textAlign: "left"}}>Total Qty</td>
                    <td style={{textAlign: "right"}}>{order.total_qty}</td>
                  </tr>
                  <tr>
                    <td style={{textAlign: "left"}}>Total Amt</td>
                    <td style={{textAlign: "right"}}>{order.total_amt_before_tax}</td>
                  </tr>
                  <tr>
                    <td style={{textAlign: "left"}}>CGST</td>
                    <td style={{textAlign: "right"}}>{order.sgst_amount}</td>
                  </tr>
                  <tr>
                    <td style={{textAlign: "left"}}>SGST</td>
                    <td style={{textAlign: "right"}}>{order.cgst_amount}</td>
                  </tr>
                  <tr>
                    <td style={{textAlign: "left"}}>TCS Amount</td>
                    <td style={{textAlign: "right"}}>{order.tcs_amount}</td>
                  </tr>
                  <tr>
                    <td style={{textAlign: "left"}}>Round Off</td>
                    <td style={{textAlign: "right"}}>{order.round_off}</td>
                  </tr>
                  <tr>
                    <td style={{textAlign: "left"}}>Total Amt After tax</td>
                    <td style={{textAlign: "right"}}>{order.total_amount}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>
          <section className="order-items">
            <table className="table table-stripped">
                <thead>
                  <tr>
                    <th>Item</th>
                    <th>qty</th>
                    <th>Rate</th>
                    <th>SGST %</th>
                    <th>CGST %</th>
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.rows}
                </tbody>
            </table>
          </section>
        </div>
      );
  }
}

class OrderItemDetails extends Component {

  render(){
    const orderitem = this.props.orderitem;
    const item = this.props.item ? this.props.item : [];
    return (
      <tr>
        <td>{item.name}({item.type})({item.hsncode})</td>
        <td>{orderitem.qty}</td>
        <td>{orderitem.before_tax_rate}</td>
        <td>{item.sgst_tax}</td>
        <td>{item.cgst_tax}</td>
        <td>{parseFloat(orderitem.qty * orderitem.before_tax_rate).toFixed(2)}</td>
      </tr>
    );
  }
}
 
export default Order;


// WEBPACK FOOTER //
// ./src/js/Order.js